module.exports = __webpack_public_path__ + "static/media/satellite.6b66e4c7.png";